
// Add file name on custom input files
let inputFile1 = document.getElementById("file1");
let containerInputFile1 = document.getElementsByClassName("file1-container")[0];
let btnCrossFile1 = document.getElementsByClassName("cross—btn-file1")[0];
let textFile1 = document.getElementsByClassName("text-input-file1")[0];

let inputFile2 = document.getElementById("file2");
let containerInputFile2 = document.getElementsByClassName("file2-container")[0];
let btnCrossFile2 = document.getElementsByClassName("cross-btn-file2")[0];
let textFile2 = document.getElementsByClassName("text-input-file2")[0];

let inputFile3 = document.getElementById("file3");
let containerInputFile3 = document.getElementsByClassName("file3-container")[0];
let btnCrossFile3 = document.getElementsByClassName("cross-btn-file3")[0];
let textFile3 = document.getElementsByClassName("text-input-file3")[0];

function initInputFiles(input, container, btnCross, text, nextInputContainer) {
    input.addEventListener("click", (e) => {
        input.onchange = function (event) {
            container.classList.add("input-file-container--active");
            btnCross.style.display = "block";
            let fileList = input.files;
            if (document.getElementsByClassName("input-file-container")[document.getElementsByClassName("input-file-container").length - 1] != container && nextInputContainer) {
                nextInputContainer.style.display = "block";
                nextInputContainer.style.opacity = "1";
            }
            if (input.files.length < 1) {
                container.classList.remove("input-file-container--active");
                text.innerText = "";
                btnCross.style.display = "none";
            } else {
                text.innerText = fileList[0].name.substring(0, 10) + " ...";
            }
        }
    })
    btnCross.addEventListener("click", function () {
        input.value = null;
        text.innerText = "";
        container.classList.remove("input-file-container--active");
        btnCross.style.display = "none";
    });
}
initInputFiles(inputFile1, containerInputFile1, btnCrossFile1, textFile1, containerInputFile2);
initInputFiles(inputFile2, containerInputFile2, btnCrossFile2, textFile2, containerInputFile3);
initInputFiles(inputFile3, containerInputFile3, btnCrossFile3, textFile3);